"use client";

import { Plus, Trash2 } from "lucide-react";
import { ROADMAP_COLORS } from "@/lib/lesson-content/schema";

/** Small form pieces shared by the block editors. */

export function ColorSelect({ value, autoLabel, onChange }: { value?: string; autoLabel: string; onChange: (color: string | undefined) => void }) {
  return (
    <select value={value ?? ""} onChange={(e) => onChange(e.target.value || undefined)} className={`${inputClass} w-36 shrink-0`} aria-label="Colour">
      <option value="">{autoLabel}</option>
      {ROADMAP_COLORS.map((c) => (
        <option key={c} value={c}>
          {c}
        </option>
      ))}
    </select>
  );
}

export function RemoveBtn({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title="Remove"
      className="rounded p-1.5 text-rose-500 hover:bg-rose-50 disabled:opacity-30"
    >
      <Trash2 className="h-3.5 w-3.5" />
    </button>
  );
}

export function AddBtn({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 text-xs font-semibold text-indigo-700 hover:text-indigo-900"
    >
      <Plus className="h-3.5 w-3.5" /> {label}
    </button>
  );
}

/** For controls made of several buttons, where a wrapping `<label>` would forward clicks to the first. */
export function FieldGroup({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div role="group" aria-label={label}>
      <span className="mb-1 block text-xs font-semibold text-slate-600">{label}</span>
      {children}
    </div>
  );
}

export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-semibold text-slate-600">{label}</span>
      {children}
    </label>
  );
}

export const inputClass =
  "w-full rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm text-slate-800 focus:border-slate-400 focus:outline-none focus:ring-1 focus:ring-slate-400";
export const textareaClass = `${inputClass} font-mono`;
